export type Lang = 'en' | 'fa';

type Dict = Record<string, { en: string; fa: string }>;

const dict: Dict = {
  appTitle: { en: 'Coco', fa: 'کوکو' },
  date: { en: 'Date (Jalali)', fa: 'تاریخ (شمسی)' },
  entities: { en: 'Entities', fa: 'موجودیت‌ها' },
  addEntity: { en: 'Add Entity', fa: 'افزودن موجودیت' },
  name: { en: 'Name', fa: 'نام' },
  type: { en: 'Type', fa: 'نوع' },
  bank: { en: 'Bank', fa: 'بانک' },
  customer: { en: 'Customer', fa: 'مشتری' },
  delete: { en: 'Delete', fa: 'حذف' },
  addPayer: { en: 'Add Payer', fa: 'افزودن پرداخت‌کننده' },
  addReceiver: { en: 'Add Receiver', fa: 'افزودن دریافت‌کننده' },
  allocate: { en: 'Allocate', fa: 'تخصیص' },
  selectEntity: { en: 'Select entity', fa: 'انتخاب موجودیت' },
  amount: { en: 'Amount', fa: 'مبلغ' },
  note: { en: 'Note', fa: 'یادداشت' },
  subLabel: { en: 'Card / sub-label (optional)', fa: 'کارت / زیرعنوان (اختیاری)' },
  target: { en: 'Receiver', fa: 'دریافت‌کننده' },
  payer: { en: 'Payer', fa: 'پرداخت‌کننده' },
  save: { en: 'Save', fa: 'ذخیره' },
  cancel: { en: 'Cancel', fa: 'انصراف' },
  editNode: { en: 'Edit Node', fa: 'ویرایش گره' },
  totalAmount: { en: 'Total amount', fa: 'مبلغ کل' },
  received: { en: 'Received', fa: 'دریافتی' },
  allocated: { en: 'Allocated', fa: 'تخصیص‌یافته' },
  toAllocate: { en: 'To allocate', fa: 'قابل تخصیص' },
  left: { en: 'Left', fa: 'باقی‌مانده' },
  remaining: { en: 'Remaining', fa: 'باقی‌مانده' },
  allocatedFrom: { en: 'Allocated from', fa: 'تخصیص از' },
  allocatedTo: { en: 'Allocated to', fa: 'تخصیص به' },
  overAlloc: { en: 'Over-allocation blocked', fa: 'تخصیص بیش از حد مسدود شد' },
  confirmDelete: { en: 'Are you sure?', fa: 'آیا مطمئن هستید؟' },
  holdToDelete: { en: 'Hold 2s to delete', fa: 'برای حذف ۲ ثانیه نگه دارید' },
  language: { en: 'Language', fa: 'زبان' },
  theme: { en: 'Theme', fa: 'تم' },
  light: { en: 'Light', fa: 'روشن' },
  dark: { en: 'Dark', fa: 'تاریک' },
  zoomIn: { en: 'Zoom in', fa: 'بزرگنمایی' },
  zoomOut: { en: 'Zoom out', fa: 'کوچک‌نمایی' },
  resetView: { en: '1:1', fa: '۱:۱' },
  empty: { en: 'No nodes yet — add a payer or receiver.', fa: 'گرهی وجود ندارد — پرداخت‌کننده یا دریافت‌کننده اضافه کنید.' },
  payers: { en: 'Payers', fa: 'پرداخت‌کننده‌ها' },
  receivers: { en: 'Receivers', fa: 'دریافت‌کننده‌ها' },
  settings: { en: 'Settings', fa: 'تنظیمات' },
  back: { en: 'Previous day', fa: 'روز قبل' },
  next: { en: 'Next day', fa: 'روز بعد' },
  currency: { en: 'Currency', fa: 'واحد پول' },
  search: { en: 'Search…', fa: 'جستجو…' },
  fullyAllocated: { en: 'Fully allocated', fa: 'تخصیص کامل' },
  today: { en: 'Today', fa: 'امروز' },
};

export function t(key: keyof typeof dict, lang: Lang): string {
  return dict[key]?.[lang] ?? (dict[key]?.en ?? String(key));
}

export function formatMoney(value: number, currency: string, lang: Lang): string {
  const num = Math.round(value * 100) / 100;
  const str = num.toLocaleString(lang === 'fa' ? 'fa-IR' : 'en-US', { maximumFractionDigits: 2 });
  return `${currency}${str}`;
}
